import { environment } from 'environments/environment';
import { paginationParams } from '../api-hooks/request';
import { Query } from '../api-hooks/types';
import { Paginated } from '@models/paginated';
import { Test } from '@models/test';

const baseUrl = environment.apiUrl + 'tests/';

type TestFilters = {
  test_code__startswith?: string;
  name__icontains?: string;
};

export const getTests = (
  page: number,
  perPage: number,
  filters: TestFilters
): Query<Paginated<Test>> => ({
  url: baseUrl,
  params: paginationParams(page, perPage, filters)
});
